import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { Icon } from '../../icon/icon';
import { SeatPickerContextInstance } from '../types/context';
import { getAppearanceForSeat } from '../utils/get-appearance-for-seat';
import { getClassForSeat } from '../utils/get-class-for-seat';
const b = bemClassBuilder('v-seat-picker-legend-item-seat');
export const SeatPickerLegendItemSeat = observer(({ legendItem }) => {
    const { config } = useContext(SeatPickerContextInstance);
    const { seatSize } = config.legend;
    const { seatType, showAsUnavailable, showAsSelected, showAsFriend, showAsHouse, customClass, customIconName } = legendItem;
    const seatAppearance = getAppearanceForSeat(seatType, !showAsUnavailable, showAsSelected || false, showAsFriend || false, showAsHouse || false, config.seats.appearance);
    const legendIconName = customIconName || seatAppearance.iconName;
    const iconClass = getClassForSeat(b, customClass, seatType, !showAsUnavailable, showAsSelected || false, showAsFriend || false, showAsHouse || false);
    return (_jsx("svg", { className: iconClass, viewBox: `0 0 ${seatSize} ${seatSize}`, width: seatSize, height: seatSize, children: _jsx(Icon, { name: legendIconName, className: b.element('icon'), size: seatSize, x: 0, y: 0 }) }));
});
SeatPickerLegendItemSeat.displayName = 'SeatPickerLegendItemSeat';
//# sourceMappingURL=legend-item-seat.js.map